import { useState } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import { Config } from "../../../../../Config/Config";
import SwivlChat from "../../../../../SwivlChat";
import { SpacePickerFilters, numberOfFiltersString } from "../SpacePicker";
import React from "react";
import {  SpaceFeatureName } from "@swivl/swivl-lib";

export const SpacePickerFiltersModal = (props:{filters:SpacePickerFilters,   delegate:SwivlChat, updateFilters(filters:SpacePickerFilters):void}) => {
  const [filters, setFilters] = useState(props.filters)
  const addOrRemoveFilter = (isAdd:boolean, filter:string, isFeature:boolean) => {
    if (!Config.canPressButtons) { 
      return; 
    }


    let newFilters = {...filters} 
    if (isAdd) {
    if (isFeature && !filters.selectedFeatures.includes(filter)) {   newFilters.selectedFeatures.push(filter)  } 
    if (!isFeature && !filters.selectedDimensions.includes(filter)) {   newFilters.selectedDimensions.push(filter)  } 
    } else {
      if (isFeature) { newFilters.selectedFeatures = newFilters.selectedFeatures.filter(i => i!==filter)  } 
      if (!isFeature) {
        
        
        newFilters.selectedDimensions = newFilters.selectedDimensions.filter(i => i!==filter)  
      

      } 
    }
    setFilters(newFilters)
  }
  const resetFilters = () => {
    if (!Config.canPressButtons) { 
      return; 
    }
    setFilters({
      dimensions:filters.dimensions,
      selectedDimensions:[],
      features:filters.features,
      selectedFeatures:[],
      featureDisplayName: filters.featureDisplayName

    })
  }
  

  const saveClicked = ()  => {
    if (!Config.canPressButtons) { 
      return; 
    }
    props.updateFilters(filters)
    props.delegate.hideModal()
  }

  const dimensions = filters.dimensions.map( d => {
    
    if (filters.selectedDimensions.includes(d)) {
      return <a key={d} className="scc-filterItem" onClick={()=> addOrRemoveFilter(false,d, false)}><div className="scc-filterCheckbox scc-isSelected"  style={{borderColor: Config.primaryButtonBackground,  background: Config.primaryButtonBackground}} ><FaCheck /> </div><span>{d}</span></a>
    } else {
      return <a key={d} className="scc-filterItem scc-filterDeselected " onClick={()=> addOrRemoveFilter(true,d, false)}><div className="scc-filterCheckbox swivl-primaryBorderHover" /><span>{d}</span></a>
    }
  })


  const features =   filters.features.map( d => {   
  

    const displayName = filters.featureDisplayName[d];
    if (filters.selectedFeatures.includes(d)) {
      return <a key={d} className="scc-filterItem " onClick={()=> addOrRemoveFilter(false,d, true)}><div className="scc-filterCheckbox scc-isSelected"  style={{borderColor: Config.primaryButtonBackground,  background: Config.primaryButtonBackground}} ><FaCheck /> </div><span>{displayName}</span></a>
    } else {
      return <a key={d} className="scc-filterItem scc-filterDeselected " onClick={()=> addOrRemoveFilter(true,d, true)}><div className="scc-filterCheckbox swivl-primaryBorderHover"/><span>{displayName}</span></a>
    }
  })


  

  return <div className="scc-FiltersModal">
      <div className="scc-filtersHeader">
        <span>FILTERS {numberOfFiltersString(filters)}</span>
        <FaTimes  onClick={props.delegate.hideModal}  />
        </div>
        <div className="scc-filtersContent">
          <b>Available Unit Sizes</b>
          <div className="scc-filtersList"> {dimensions}</div>
          {filters.features.length ? <><b>Unit Type</b>
            <div className="scc-filtersList"> {features}</div>
          </> : null}
        </div> 

        <div className="scc-filtersFooter swivl-linkContainer">
          <a onClick={resetFilters}>Reset Filters</a>
          <div onClick={saveClicked} className="scc-filtersSaveButton swivl-primaryButton">Save</div>
          </div>
  </div>
}
